// Vector A4 output from the same presentation data as DocumentoBoletoBancario.
export function renderBankSlipPdf(doc, data, { qrCode, barcode, logo } = {}) {
  const margin = 12, width = 186, bottom = 285;
  let y = margin;
  const font = (size, bold = false) => { doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setFontSize(size); };
  const lines = (text, available, size = 9, bold = false) => { font(size, bold); return doc.splitTextToSize(String(text), available); };
  const room = height => { if (y + height > bottom) { doc.addPage(); y = margin; } };
  const write = (text, x, top, size = 9, bold = false, options) => { font(size, bold); doc.text(text, x, top, options); };
  const rule = top => { doc.setDrawColor(30); doc.setLineWidth(0.2); doc.line(margin, top, margin + width, top); };
  if (data.school?.name || data.school?.details.length) {
    const x = margin + (logo ? 31 : 0), available = width - (x - margin);
    const top = y;
    if (logo) {
      const props = doc.getImageProperties(logo);
      const scale = Math.min(26 / props.width, 20 / props.height);
      doc.addImage(logo, 'PNG', margin, y, props.width * scale, props.height * scale);
    }
    if (data.school.name) {
      const name = lines(data.school.name, available, 12, true);
      write(name, x, y + 4, 12, true); y += name.length * 5 + 1;
    }
    for (const detail of data.school.details) {
      const wrapped = lines(detail, available, 8);
      write(wrapped, x, y + 3, 8); y += wrapped.length * 3.5;
    }
    y = Math.max(y, top + (logo ? 20 : 0)) + 2;
    rule(y); y += 2;
  }
  if (data.warning) { write(data.warning, margin, y + 4, 11, true); y += 12; }
  if (data.pix) {
    const px = margin + (qrCode ? 40 : 0), pw = width - (qrCode ? 40 : 0);
    const payload = lines(data.pix, pw, 8);
    const height = Math.max(36, 21 + payload.length * 3.3);
    if (qrCode) doc.addImage(qrCode, 'PNG', margin, y, 34, 34);
    write('PIX / INFORMATIVO', px, y + 4, 11, true);
    write('Pague via Pix utilizando o aplicativo da sua instituição financeira.', px, y + 10, 8);
    write('Pix Copia e Cola', px, y + 16, 8, true);
    write(payload, px, y + 21, 8);
    y += height + 4;
  }
  const financialFields = data.financialFields || [];
  const financialWidth = financialFields.length ? 46 : 0;
  const mainWidth = width - financialWidth;
  const financialLayouts = financialFields.map(field => {
    const size = field.kind === 'amount' ? 17 : field.kind === 'due' ? 14 : 9;
    const valueLines = field.value ? lines(field.value, financialWidth - 6, size, true) : [];
    return { ...field, size, valueLines, height: Math.max(7, 6 + valueLines.length * size * 0.4) };
  });
  const rowLayouts = data.rows.map(row => {
    const cellWidth = mainWidth / row.length;
    const cells = row.map(field => ({ ...field, labelLines: lines(field.label, cellWidth - 4, 7), valueLines: lines(field.value, cellWidth - 4, 9, true) }));
    const padding = row.length === 1 && row[0].label === 'Instruções' ? 2 : 4;
    return { cells, cellWidth, height: Math.max(...cells.map(cell => cell.labelLines.length * 2.8 + cell.valueLines.length * 3.6)) + padding };
  });
  for (const [index, title] of ['RECIBO DO PAGADOR', 'FICHA DE COMPENSAÇÃO'].entries()) {
    const mainHeight = rowLayouts.reduce((sum, row) => sum + row.height, 0);
    const financialHeight = financialLayouts.reduce((sum, field) => sum + field.height, 0);
    const bodyHeight = Math.max(mainHeight, financialHeight);
    const sectionHeight = 19 + bodyHeight + (index && data.barcode ? 26 : 0);
    if (index) { y += 5; doc.setLineDashPattern([1, 1], 0); rule(y); doc.setLineDashPattern([], 0); y += 6; }
    room(sectionHeight);
    write(title, margin, y + 4, 10, true); y += 8;
    const bank = [data.bankName, data.bankCode].filter(Boolean).join(' | ');
    write(bank, margin, y + 5, 13, true);
    const bankWidth = doc.getTextWidth(bank) + 12;
    if (data.line) {
      doc.setFont('courier', 'bold');
      doc.setFontSize(9);
      const line = doc.splitTextToSize(data.displayLine || data.line, width - bankWidth);
      doc.text(line, margin + width, y + 5, { align: 'right' });
      y += Math.max(10, line.length * 4 + 3);
    } else y += 10;
    rule(y);
    const bodyTop = y;
    for (const row of rowLayouts) {
      room(row.height);
      row.cells.forEach((cell, i) => {
        const x = margin + i * row.cellWidth;
        if (i) doc.line(x, y, x, y + row.height);
        write(cell.labelLines, x + 2, y + 3, 7);
        write(cell.valueLines, x + 2, y + 3 + cell.labelLines.length * 2.8 + 1, 9, true);
      });
      y += row.height;
      doc.line(margin, y, margin + mainWidth, y);
    }
    if (financialLayouts.length) {
      const x = margin + mainWidth;
      doc.line(x, bodyTop, x, bodyTop + bodyHeight);
      const extra = (bodyHeight - financialHeight) / financialLayouts.length;
      let top = bodyTop;
      for (const field of financialLayouts) {
        const height = field.height + extra;
        write(field.label.toLocaleUpperCase('pt-BR'), margin + width - 3, top + 3, 7, false, { align: 'right' });
        if (field.valueLines.length) write(field.valueLines, margin + width - 3, top + 5 + field.size * 0.35, field.size, true, { align: 'right' });
        top += height;
        doc.line(x, top, margin + width, top);
      }
    }
    y = bodyTop + bodyHeight;
    rule(y);
    if (index && data.barcode) {
      room(26); y += 5;
      if (barcode) doc.addImage(barcode, 'PNG', margin, y, 103, 13);
      write(data.barcode, margin, y + 17, 8);
      y += 22;
      write('FICHA DE COMPENSAÇÃO', margin + width - 48, y, 9, true);
    }
  }
}
